import { SearchTerm } from "./SearchTerm";

const AccessGroupReportSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "agName",
        translationKey: "name"
    },
    {
        heading: "Access Area",
        accessor: "area",
        searchOnName: "area.areaName",
        translationKey: "accessArea"
    },
    {
        heading: "Access Time Pattern",
        accessor: "accessTimePatterns",
        searchOnName: "accessTimePattern.atpName",
        translationKey: "accessTimePattern"
    },
    {
        heading: "Max Capacity",
        accessor: "maxCapacity",
        searchOnName: "agMaxCapacity",
        translationKey: "maxCapacity"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
    {
        heading: "Group Type",
        accessor: "groupType",
        searchOnName: "agType",
        translationKey: "groupType"
    }
]

export default AccessGroupReportSearch;
